import CryptoJS from 'crypto-js';

// 这是一个示例密钥，生产环境建议通过环境变量或其他方式注入，
// 或者至少不要直接写在代码最显眼的地方。
// 但前端加密本质上是“防君子不防小人”，因为密钥最终必须在客户端解密。
// 为了提高安全性，我们可以采用混淆、动态密钥等策略。
const SECRET_KEY = 'YOUR_SECRET_KEY_HERE'; 

export const encryptData = (data: any): string => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

export const decryptData = (ciphertext: string): any => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(originalText);
  } catch (error) {
    console.error('Failed to decrypt data:', error);
    return null;
  }
};

// 模拟从远程获取加密数据
export const fetchEncryptedData = async (url: string) => {
    try {
        // Add timestamp to prevent caching
        const response = await fetch(`${url}?t=${new Date().getTime()}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const encryptedText = await response.text(); // 假设返回的是纯文本的加密字符串
        return decryptData(encryptedText);
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
}
